export const StringHelper = {
  removeWhitespaces: (value: string): string => value.replace(/\s+/g, ''),
  standarizeStringCode: (value: string): string => value.replace(' ', '_'),
  formatPhoneNumber: (value: string): string => value.replace(/^(.\d\d)(\d{3})(\d{3})(.*)/, '$1 $2 $3 $4'),
  capitalizeFirstLetter: (value: string): string => value[0].toUpperCase() + value.slice(1)
};
